import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/Card";
import { getProviderTileTone, ProviderIcon } from "@/components/ui/ProviderIcon";
import { cn } from "@/lib/utils";
import { STATUS_COLORS } from "@/pages/InvoicesPage.styles";
import * as shared from "@/styles/shared";
import type { AddressCardProps } from "@/types/addressCard";
import type { Status } from "@shared/types/models";
import { formatCurrency } from "@shared/utils";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import * as styles from "./AddressCard.styles";

const AddressCard = ({ address, combos }: AddressCardProps) => {
  const { t } = useTranslation(["common", "dashboard"]);

  return (
    <Card variant="elevated" className={shared.transitionDefault}>
      <CardHeader className={styles.cardHeader}>
        <CardTitle className={styles.cardTitle}>{address}</CardTitle>
      </CardHeader>
      <CardContent className={styles.cardContent}>
        {combos.map((combo) => {
          const tone = getProviderTileTone(combo.provider);
          const content = (
            <>
              <span className={cn(styles.providerTile, tone.bg, tone.text)}>
                <ProviderIcon provider={combo.provider} size="md" className={tone.text} title={combo.provider} />
              </span>
              {combo.status ? (
                <>
                  {combo.amount != null && <span className={styles.invoiceAmount}>{formatCurrency(combo.amount)}</span>}
                  <span className={cn(styles.statusBadge, STATUS_COLORS[combo.status as Status])}>
                    {t(`common:status.${combo.status.toLowerCase()}`, combo.status)}
                  </span>
                </>
              ) : (
                <span className={styles.statusNoInvoice}>{t("dashboard:noInvoice")}</span>
              )}
            </>
          );

          return combo.id ? (
            <Link key={combo.id} to={`/invoices/${combo.id}`} className={cn(styles.providerRow, styles.providerRowLinkable)}>
              {content}
            </Link>
          ) : (
            <div key={combo.provider} className={styles.providerRow}>
              {content}
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
};

export { AddressCard };
